import React from 'react'
import PropTypes from 'prop-types'
import { GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid-pro'
import FilterToggleButton from './FilterToggleButton'

const CustomToolbar = ({ sortButton, ...props }) => {
  return (
    <GridToolbarContainer
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        flexWrap: 'wrap',
      }}
    >
      <FilterToggleButton />
      <GridToolbarQuickFilter
        variant="outlined"
        size="small"
        sx={{
          flex: 1,
          minWidth: 120,
        }}
        fullWidth
        {...props}
      />
      {sortButton}
    </GridToolbarContainer>
  )
}

CustomToolbar.propTypes = {
  showQuickFilter: PropTypes.bool,
  sortButton: PropTypes.node,
}

export default CustomToolbar
